import { useAccountBanStore } from '../stores/account-ban.store';

const SUPPORT_EMAIL = 'support@empathease.app';

/**
 * Full-screen "Account suspended" view, raised by useAccountBanStore.suspend()
 * on any `account_banned` 403. Single instance, mounted in app.tsx.
 */
export default function AccountSuspendedScreen() {
  const notice = useAccountBanStore((s) => s.notice);
  const dismiss = useAccountBanStore((s) => s.dismiss);

  if (!notice) return null;

  // The server's message ends with the Apple link for clients that only show
  // text; here the link is a button, so the sentence ends at "cancel it."
  const url = notice.manageSubscriptionUrl;
  const text =
    url && notice.message.endsWith(url)
      ? notice.message.slice(0, -url.length).replace(/:\s*$/, '.')
      : notice.message;

  const backToSignIn = () => {
    dismiss();
    if (window.location.pathname !== '/login') window.location.href = '/login';
  };

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="account-suspended-title"
      className="fixed inset-0 z-(--ee-z-suspended) flex items-center justify-center overflow-y-auto bg-base-100 px-4 py-8"
    >
      <div className="w-full max-w-md text-center">
        <h1 id="account-suspended-title" className="text-2xl font-bold text-base-content">
          Account suspended
        </h1>
        <p className="mt-4 whitespace-pre-line break-words text-base-content/80">{text}</p>
        <div className="mt-6 flex flex-col gap-3">
          <a href={`mailto:${SUPPORT_EMAIL}`} className="btn btn-primary">
            Contact {SUPPORT_EMAIL}
          </a>
          {notice.manageSubscriptionUrl ? (
            <a
              href={notice.manageSubscriptionUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline"
            >
              Manage your Apple subscription
            </a>
          ) : null}
          <button type="button" onClick={backToSignIn} className="btn btn-ghost">
            Back to sign in
          </button>
        </div>
      </div>
    </div>
  );
}
